import BasicDropdown from '@tock/shared/components/inputs/basic-dropdown/BasicDropdown';
import ConsumerDropdownOption from 'components/business/ConsumerDropdownOption';
import _ from 'lodash';

interface Props {
  partnerName?: string;
  onChangeBookings(option: SelectOption): void;
}
const PartnerBookingsDropdown = ({ partnerName, onChangeBookings }: Props) => {
  const options = [
    {
      key: 'reservations',
      value: 'reservations',
      label: 'My reservations',
    },
    {
      key: 'partner-bookings',
      value: 'reservations/partner',
      label: `${partnerName} reservations`,
    },
  ];

  return (
    <BasicDropdown
      component={ConsumerDropdownOption}
      contextClassName="PartnerBookingsDropdown"
      options={options}
      onSelect={onChangeBookings}
      selectedOption={_.includes(location.pathname, '/partner') ? options[1] : options[0]}
    />
  );
};

export default PartnerBookingsDropdown;
